export default {
	name: 'queryBookBorrowHistory',
	data() {
		return {
			getData: {},
			history: [],
			book: {},
			pageIndex: 1,
			pageRows: 10,
			count: 0
		};
	},
	created() {
		this.getData = function() {
			let BookDetailID = this.$route.params.BookDetailID;
			this.$request.request({
				url: 'books/booksMoveHistory',
				data: {
					pageCount: this.pageRows,
					pageIndex: this.pageIndex,
					BookDetailID: BookDetailID
				},
				method: 'post'
			}).then(res => {
				if (res.result) {
					this.book = res.book;
					this.history = res.moveHistory;
					this.count = res.count;
				}
			});
		}
		this.getData();
	},
	methods: {
		changePages(s) {
			if (s == 'up') {
				if (this.pageIndex == 1)
					return;
				else
					this.pageIndex--;

			} else {
				if (this.pageIndex * this.pageRows >= this.count)
					return;
				else
					this.pageIndex++;
			}

			this.getData();
		},
		changePageRows() {
			if (this.pageIndex * this.pageRows >= this.count)
				this.pageIndex = 1;
			this.getData();
		}
	},
	computed: {
		up() {
			if (this.pageIndex == 1)
				return true;
			else
				return false;
		},
		down() {
			if (this.pageIndex * this.pageRows >= this.count)
				return true;
			else
				return false;
		},
		page() {
			if (Math.ceil((this.count / this.pageRows)) == 0)
				return this.pageIndex + '/' + 1 + '页';
			else
				return this.pageIndex + '/' + Math.ceil((this.count / this.pageRows)) + '页';
		}
	},
	filters: {},
	watch: {
		$route(n, o) {
			if (n.path.indexOf('queryBookMoveHistory') == -1) return;
			let nbooksid = n.params.BookDetailID;
			let obooksid = o.params.BookDetailID;
			if (nbooksid != obooksid)
				this.getData();
		}

	},
	activated() {
		this.getData();
	}


}
